import { connect } from "react-redux";
import FileStatusDistribution from "./Management/FileStatusDistribution";
import AverageFileClearanceTime from "./Management/AverageFileClearanceTime";
import FileDelayedTime from "./Management/FileDelayedTime";
import EscalationTrendsChart from "./Management/EscalationTrends";
import KPIData from "./Management/KPIData";
import { Row, Col } from "react-bootstrap";
import ReceiveFileCount from "./DaakUser/ReceiveFileCount";
import DispatchFileCount from "./DaakUser/DispatchFileCount";
import ReceiveFileList from "./DaakUser/ReceiveFileList";
import DispatchFileList from "./DaakUser/DispatchFileList";
import FileStatus from "./User/FileStatus";
import WeeklyFilesLineChart from "./User/WeeklyCompletedFile";
import FileActivityChart from "./Admin/FileActivity";
import FileCategoryChart from "./Admin/FileCatagoryOverTime";
import MonthlyOverdueFilesChart from "./Admin/MonthlyOverdueFile";
import ExternalVsInternalChart from "./Admin/ExternalvsInternal";
import TopEscalatingDepartmentsChart from "./Admin/TopEscalatingDepartment";
import TopDelayedFiles from "./Admin/TopDelayedFile";
import FileVolumeTrendsChart from "./Management/FileVolumeTrends";
import FileToCollect from "./User/FileToCollect";
import FileToOut from "./User/FileToOut";
import Employeedashboard from "../employeehome/Employeedashboard";
import Driverdashboard from "../Driverhome.js/Driverdashboard";
import Admindashboard from './admindashboard'
function Home({ userRole }) {
  const Getdashboard = () => {
    if (userRole.toLowerCase() === "employee") {
      return <Employeedashboard />;
    }
    else if (userRole.toLowerCase() === "driver"){
      return <Driverdashboard/>
    }
    else if (userRole.toLowerCase() === "admin"){
      return <Admindashboard/>
    }
    else {
      return <h3>Dashboard</h3>;
    }
  };
  return <Getdashboard />;
}

const mapStateToProps = (state) => ({
  userRole: state.auth.user?.role || "user",
});
export default connect(mapStateToProps)(Home);
